export default function c_cover(child, parent) {
    for (let key in parent) {
        child[key] = parent[key];
    }
}
